import React, { useEffect } from "react";
import EditProfile from "../EditProfile";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../../features/authSlice";

const PerusahaanProfileEdit = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, user } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
    if (user && user.role !== "perusahaan") {
      navigate("/dashboard");
    }
  }, [isError, user, navigate]);
  return <EditProfile />;
};

export default PerusahaanProfileEdit;
